// extracted by css-extract-rspack-plugin
export default {"cls1":"Bookmarkers-cls1_ux6","cls2":"Bookmarkers-cls2_U-4 Bookmarkers-cls1_ux6"};